import { OmitKeyof, QueryObserverOptions } from '@tanstack/react-query';

export const deafultConfig: OmitKeyof<
	QueryObserverOptions<unknown, unknown>,
	'suspense' | 'queryKey'
> = {
	gcTime: 1000 * 60 * 60 * 24, // 24 hours
	staleTime: 1000 * 60 * 5,
	// Отключаем повторный запрос при возвращении фокуса в окно
	refetchOnWindowFocus: false,
	// Отключаем повторный запрос при повторном монтировании компонента
	refetchOnReconnect: false,
	// Настроим поведение при фокусе, например, если это нежелательно
	refetchInterval: false, // Отключаем периодический запрос
	refetchOnMount: false,
	refetchIntervalInBackground: false,
	retry: false,
	retryOnMount: false,
};
